export var ApiErrorCategories;
(function (ApiErrorCategories) {
    ApiErrorCategories[ApiErrorCategories["DANGER"] = 0] = "DANGER";
    ApiErrorCategories[ApiErrorCategories["WARNING"] = 1] = "WARNING";
    ApiErrorCategories[ApiErrorCategories["INFO"] = 2] = "INFO";
})(ApiErrorCategories || (ApiErrorCategories = {}));
//# sourceMappingURL=api-error-categories.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/http/api-error-categories.js
// module id = 847
// module chunks = 14